import React, { useState, useEffect } from 'react';
import { Card } from '../layout';
import DrawDateBadge from '../DrawDateBadge';

export default function HeroCarousel({ slides, drawDate }) {
  const [currentSlide, setCurrentSlide] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % slides.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [slides.length]);

  return (
    <Card padding="p-0" className="relative group/carousel hover:shadow-2xl transition-shadow duration-300 overflow-hidden">
        <div className="relative hero-fullscreen-mobile md:h-[32rem]">
          <DrawDateBadge
            draw={drawDate}
            compact
            className="absolute left-1/2 top-4 z-10 -translate-x-1/2 sm:left-auto sm:right-6 sm:top-6 sm:translate-x-0"
          />
          {slides.map((slide, index) => {
            const Icon = slide.icon;
            return (
              <div
                key={index}
                className={`absolute inset-0 transition-all duration-700 ${
                  index === currentSlide
                    ? 'opacity-100 scale-100'
                    : 'opacity-0 scale-95 pointer-events-none'
                }`}
              >
                <div className={`absolute inset-0 bg-gradient-to-br ${slide.bgGradient}`}></div>
                <div className="absolute inset-0 flex items-center justify-center px-4 sm:px-8">
                  <div className="text-center text-white max-w-2xl">
                    <Icon className="w-16 h-16 sm:w-20 sm:h-20 md:w-24 md:h-24 mx-auto mb-6 drop-shadow-2xl" strokeWidth={1.5} />
                    <h2 className="text-3xl sm:text-4xl md:text-5xl font-black mb-4 drop-shadow-lg">
                      {slide.title}
                    </h2>
                    <p className="text-lg sm:text-xl mb-8 drop-shadow-md font-medium">
                      {slide.subtitle}
                    </p>
                    <div className="inline-block bg-white/20 backdrop-blur-md border-2 border-white/50 rounded-full px-6 py-3 sm:px-10 sm:py-4 font-bold text-base sm:text-lg shadow-2xl">
                      {slide.stats}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="absolute bottom-4 sm:bottom-6 left-0 right-0 flex justify-center gap-2 sm:gap-3 z-10">
          {slides.map((_, index) => (
            <button
              key={index}
              onClick={() => setCurrentSlide(index)}
              className={`transition-all duration-300 rounded-full ${
                index === currentSlide
                  ? 'bg-white w-12 h-3 shadow-lg'
                  : 'bg-white/60 w-3 h-3 hover:bg-white/90 hover:scale-125'
              }`}
            />
          ))}
        </div>
      </Card>
  );
}
